export default __webpack_public_path__ + "static/media/book-shop.2656d7e3.PNG";